import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import tenantService from './tenantService';
import { toast } from 'react-toastify';

const initialState = {
  tenant: null,
  limits: null,
  usage: null,
  loading: false,
  error: false,
  success: false,
  message: ''
};

// Registrar nuevo comercio
export const registerTenant = createAsyncThunk(
  'tenant/register',
  async (tenantData, thunkAPI) => {
    try {
      return await tenantService.registerTenant(tenantData);
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Verificar subdominio
export const checkSubdomain = createAsyncThunk(
  'tenant/checkSubdomain',
  async (subdomain, thunkAPI) => {
    try {
      return await tenantService.checkSubdomain(subdomain);
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Obtener info del comercio
export const getTenantInfo = createAsyncThunk(
  'tenant/getInfo',
  async (_, thunkAPI) => {
    try {
      return await tenantService.getTenantInfo();
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Actualizar info del comercio
export const updateTenantInfo = createAsyncThunk(
  'tenant/updateInfo',
  async (data, thunkAPI) => {
    try {
      return await tenantService.updateTenantInfo(data);
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Actualizar plan
export const upgradePlan = createAsyncThunk(
  'tenant/upgradePlan',
  async (plan, thunkAPI) => {
    try {
      return await tenantService.upgradePlan(plan);
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const tenantSlice = createSlice({
  name: 'tenant',
  initialState,
  reducers: {
    reset: (state) => {
      state.loading = false;
      state.error = false;
      state.success = false;
      state.message = '';
    }
  },
  extraReducers: (builder) => {
    builder
      // Register Tenant
      .addCase(registerTenant.pending, (state) => {
        state.loading = true;
        state.error = false;
        state.success = false;
      })
      .addCase(registerTenant.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.tenant = action.payload.tenant;
        toast.success('Comercio registrado exitosamente');
      })
      .addCase(registerTenant.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.message = action.payload;
        toast.error(action.payload);
      })
      // Get Tenant Info
      .addCase(getTenantInfo.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTenantInfo.fulfilled, (state, action) => {
        state.loading = false;
        state.tenant = action.payload.tenant;
        state.limits = action.payload.limits;
        state.usage = action.payload.usage;
      })
      .addCase(getTenantInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.message = action.payload;
      })
      // Update Tenant Info
      .addCase(updateTenantInfo.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateTenantInfo.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.tenant = action.payload.tenant;
        toast.success('Información actualizada');
      })
      .addCase(updateTenantInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.message = action.payload;
        toast.error(action.payload);
      })
      // Upgrade Plan
      .addCase(upgradePlan.pending, (state) => {
        state.loading = true;
      })
      .addCase(upgradePlan.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.tenant = { ...state.tenant, ...action.payload.tenant };
        state.limits = action.payload.tenant.limits;
        toast.success(action.payload.message);
      })
      .addCase(upgradePlan.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.message = action.payload;
        toast.error(action.payload);
      });
  }
});

export const { reset } = tenantSlice.actions;
export default tenantSlice.reducer;
